import request from '@/utils/request'

export function enroll (params) {
  return request({
    url: process.env.WEB_API + '/enroll/enroll',
    method: 'post',
    data: params
  })
}

export function getLastEnrollInfo (params) {
  return request({
    url: process.env.WEB_API + '/enroll/getLastEnrollInfo',
    method: 'get',
    params
  })
}

export function getUserEnrollCount (params) {
  return request({
    url: process.env.WEB_API + '/enroll/getUserEnrollCount',
    method: 'get',
    params
  })
}

export function readUserEnrollCount (params) {
  return request({
    url: process.env.WEB_API + '/enroll/readUserEnrollCount',
    method: 'post',
    data: params
  })
}



// WEBPACK FOOTER //
// ./src/api/enroll.js